// src/components/Card/CardInfoCard.jsx
import React, { useState } from 'react';
import './CardInfoCard.css';
import { Card, Divider, Modal, message } from 'antd';
import { ReactComponent as EditIcon } from '../../assets/icon/edit.svg';
import { ReactComponent as CopyIcon } from '../../assets/icon/copy.svg';
import { ReactComponent as CorrectIcon } from '../../assets/icon/check.svg';
import { ReactComponent as IncorrectIcon } from '../../assets/icon/close.svg';
import RichTextEditor from "../RichTextEditor/RichTextEditor";
import EditCardForm from "../EditCardForm/EditCardForm";
import InfoCardFooter, {
    InfoCardCounter,
    InfoCardIconButton,
} from "../InfoCardFooter/InfoCardFooter";
import useIsMobile from "../../hooks/useIsMobile";
import useTranslation from "../../hooks/useTranslation";
import { richTextToPlainText } from "../../utils/richText";

const CardInfoCard = ({ card, onUpdateCard, onDeleteCard }) => {
    const { t } = useTranslation();
    const [isModalVisible, setIsModalVisible] = useState(false);
    const isMobile = useIsMobile();

    const showModal = () => {
        setIsModalVisible(true);
    };

    const handleCancel = () => {
        setIsModalVisible(false);
    };

    const handleSave = (updatedCard) => {
        onUpdateCard?.(updatedCard);
        setIsModalVisible(false);
    };

    const handleDelete = (cardId) => {
        onDeleteCard?.(cardId);
        setIsModalVisible(false);
    };

    // Карточку копируем текстом — вопрос, пустая строка, ответ: в таком виде её
    // можно сразу вставить в заметки или в подсказку для ИИ.
    const handleCopy = () => {
        const copiedCard = [richTextToPlainText(card.question), richTextToPlainText(card.answer)]
            .filter((part) => part !== '')
            .join('\n\n');

        navigator.clipboard
            .writeText(copiedCard)
            .then(() => {
                message.success(t('common.copied'));
            })
            .catch((error) => {
                message.error(t('common.copyFailed'));
                console.error(error);
            });
    };

    return (
        <>
            <Card
                key={card.id}
                className="cardInfoCard"
                bordered={false}
                styles={{ body: { padding: 0 } }}
            >
                <div style={{ padding: '16px 16px 0 16px' }}>
                    {/* Вопрос */}



                    <RichTextEditor readOnly={true} initialContent={card.question} />

                    <Divider style={{ margin: '2px 0' }} />
                    <RichTextEditor readOnly={true} textColor="#6E6E6E" initialContent={card.answer}/>





                    {/* Горизонтальный разделитель */}
                    <Divider style={{ margin: '2px 0' }} />

                    {/* Счётчики ответов и действия над карточкой */}
                    <InfoCardFooter>
                        <InfoCardCounter
                            icon={CorrectIcon}
                            title={t('common.correctAnswers')}
                            value={card.correctAnswerCount}
                        />
                        <InfoCardCounter
                            icon={IncorrectIcon}
                            title={t('common.incorrectAnswers')}
                            value={card.incorrectAnswerCount}
                        />
                        <InfoCardIconButton icon={CopyIcon} title={t('common.copy')} onClick={handleCopy} />
                        <InfoCardIconButton icon={EditIcon} title={t('common.edit')} onClick={showModal} />
                    </InfoCardFooter>
                </div>
            </Card>

            <Modal
                title={t('card.editTitle')}
                open={isModalVisible}
                onCancel={handleCancel}
                footer={null}
                width={isMobile ? '90%' : '60%'}
                style={{ top: '10%' }}
                destroyOnClose
            >
                <EditCardForm
                    card={card}
                    deckId={card.deckId}
                    onSave={handleSave}
                    onCancel={handleCancel}
                    onDelete={handleDelete}
                />
            </Modal>
        </>
    );
};

export default CardInfoCard;
